module.exports = __webpack_public_path__ + "static/media/upgrade.5d252f4f.mp3";